module.exports = __webpack_public_path__ + "img/access_6_ja.89a6c2bb.jpg";